import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PackagingSystemInfoDto } from 'src/app/data-transfer/entities/packaging-system-entities/packaging-system-info-dto';
import { PackagingSystemApiService } from 'src/app/data-transfer/services/packaging-system-api-service';
import { DialogActions } from 'src/app/model/dictionary';
import { PaginationDataSource } from 'src/app/util/pagination-datasource';
import { PackagingSystemsOverviewComponent } from '../../directory-tree/components/packaging-systems-overview/packaging-systems-overview.component';

@Component({
  selector: 'app-selection-dialog-packaging-systems',
  templateUrl: './selection-dialog-packaging-systems.component.html',
  styleUrls: ['./selection-dialog-packaging-systems.component.scss']
})
export class SelectionDialogPackagingSystemsComponent {
  @ViewChild('packagingSystemsTable') packagingSystemsTable!: PackagingSystemsOverviewComponent;

  dataSource: PaginationDataSource<PackagingSystemInfoDto>;
  displayedColumns: string[] = [];

  constructor(
    protected dialogRef: MatDialogRef<SelectionDialogPackagingSystemsComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: any,
    private packagingSystemApiService: PackagingSystemApiService
  ) {
    this.dataSource = new PaginationDataSource<PackagingSystemInfoDto>(x => this.packagingSystemApiService.getPackagingSystemsByPage(x));
    if (data) {
      this.displayedColumns = data.displayedColumns;
    }
  }

  importPackagingSystems() {
    this.dialogRef.close({ event: DialogActions.CONFIRM, selectedPackagingSystemIds: this.packagingSystemsTable.selectedPackagingSystemIds });
  }

  closeDialog() {
    this.dialogRef.close({ event: DialogActions.REJECT });
  }
}
